
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
a,
ul,
li{
  color:inherit;
  text-decoration:inherit;
  list-style-type:none;
  margin-left:0;
  padding-left:0;
  margin-block-start:0;
  margin-block-end:0;
  margin-inline-start:0;
  margin-inline-end:0;
  padding-inline-start:0;
}
:host {
  display:block;
}
.navigation nav > ul {
  border-radius:0.375rem;
}
.navigation nav > ul {
  border-width:1px;
}
.navigation nav > ul {
  border-style:solid;
}
.navigation nav > ul {
  border-color:var(--bh-neutral-default);
}
@media (min-width: 1280px) {
  .navigation nav > ul {
    justify-content:center;
  }
}
.navigation nav > ul{
    line-height:1.2;
  }
.navigation nav > ul > li:first-of-type > a {
  border-top-left-radius:0.375rem;
}
.navigation nav > ul > li:last-of-type > a {
  border-bottom-left-radius:0.375rem;
}
.navigation nav > ul > li > a {
  padding-left:1rem;
}
.navigation nav > ul > li > ul > li > a {
  padding-left:1.5rem;
}
.navigation nav > ul > li > ul > li > ul > li > a {
  padding-left:2rem;
}
.navigation nav ul {
  width:100%;
}
.navigation nav > ul ul {
  display:none;
}
.navigation nav li {
  font-family:var(--bh-ff-body);
}
.navigation nav li {
  font-size:var(--bh-fs-body-01);
  line-height:var(--bh-lh-body-01);
  letter-spacing:var(--bh-ls-body-01);
}
.navigation nav li {
  display:flex;
}
.navigation nav li {
  width:100%;
}
.navigation nav li {
  flex-wrap:wrap;
}
.navigation nav li {
  justify-content:space-between;
}
.navigation nav a {
  display:flex;
}
.navigation nav a {
  flex-grow:1;
}
.navigation nav a {
  padding:1rem;
}
.navigation nav a {
  font-family:var(--bh-ff-body);
}
.navigation nav a {
  font-size:var(--bh-fs-body-01);
  line-height:var(--bh-lh-body-01);
  letter-spacing:var(--bh-ls-body-01);
}
.navigation nav a {
  font-weight:var(--fw-bold);
}
.navigation nav a{
    width:calc(100% - 50px);
  }
.navigation nav li.has-children > a {
  padding-right:0px;
}
.navigation nav li.has-children > a:after {
  margin-left:auto;
}
.navigation nav li.has-children > a:after {
  height:100%;
}
.navigation nav li.has-children > a:after {
  min-height:1.25rem;
}
.navigation nav li.has-children > a:after {
  border-width:0px;
}
.navigation nav li.has-children > a:after {
  border-right-width:1px;
}
.navigation nav li.has-children > a:after {
  border-style:solid;
}
.navigation nav li.has-children > a:after {
  border-color:var(--bh-neutral-dark);
}
.navigation nav li.has-children > a:after {
  padding-left:0.5rem;
}
.navigation nav li.has-children > a:after{
    content:'';
  }
.navigation nav li.has-children > a:after:hover {
  border-color:var(--bh-neutral-white);
}
.navigation nav li.has-children > a:hover:after {
  border-color:var(--bh-neutral-white);
}
.navigation nav ul ul a {
  font-weight:var(--fw-normal);
}
.navigation nav ul {
  background-color:var(--neutral-white);
}
.navigation nav ul button.dropdown-trigger {
  padding-right:1rem;
}
.navigation nav ul ul {
  background-color:var(--bh-brand-primary-lightest);
}
.navigation nav ul ul a a, .navigation nav ul ul button.dropdown-trigger a {
  padding-left:0px;
  padding-right:0px;
}
.navigation nav ul ul a {
  padding-left:1.25rem;
}
.navigation nav ul ul ul {
  background-color:var(--bh-brand-primary-lighter);
}
.navigation nav ul ul ul a, .navigation nav ul ul ul button.dropdown-trigger {
  padding-left:1.5rem;
  padding-right:1.5rem;
}
.navigation nav ul ul ul a a, .navigation nav ul ul ul button.dropdown-trigger a {
  padding-left:0px;
  padding-right:0px;
}
.navigation nav li[is-dropdown-open] > button.dropdown-trigger ghs-icon {
  padding-left:0px;
}
.navigation nav li[is-dropdown-open] > button.dropdown-trigger ghs-icon {
  padding-right:0.5rem;
}
.navigation nav li[is-dropdown-open] > button.dropdown-trigger ghs-icon {
  color:var(--bh-neutral-black);
}
.navigation nav li[is-dropdown-open] > button.dropdown-trigger ghs-icon{
    transform:rotate(180deg);
  }
.navigation nav li[is-dropdown-open] > button.dropdown-trigger:hover ghs-icon, .navigation nav li[is-dropdown-open] > button.dropdown-trigger:active ghs-icon {
  color:var(--bh-brand-primary-dark);
}
.navigation nav li[is-dropdown-open] > button.dropdown-trigger:hover ghs-icon, .navigation nav li[is-dropdown-open] > button.dropdown-trigger:active ghs-icon{
        transform:rotate(180deg) translateY(20%);
      }
.navigation nav li[is-dropdown-open] > ul {
  display:block;
}
.navigation nav a:hover {
  display:flex;
}
.navigation nav a:hover {
  cursor:pointer;
}
.navigation nav a:hover {
  background-color:var(--bh-brand-primary-default);
}
.navigation nav a:hover {
  color:var(--bh-neutral-white);
}
.navigation nav a:hover + button.dropdown-trigger {
  background-color:var(--bh-brand-primary-default);
}
.navigation nav a:hover + button.dropdown-trigger ghs-icon {
  color:var(--bh-neutral-white);
}
.navigation button.dropdown-trigger {
  position:relative;
}
.navigation button.dropdown-trigger {
  display:flex;
}
.navigation button.dropdown-trigger {
  min-width:22px;
}
.navigation button.dropdown-trigger {
  max-width:46px;
}
.navigation button.dropdown-trigger {
  cursor:pointer;
}
.navigation button.dropdown-trigger {
  align-items:center;
}
.navigation button.dropdown-trigger {
  justify-content:space-between;
}
.navigation button.dropdown-trigger {
  border-width:0px;
}
.navigation button.dropdown-trigger {
  background-color:var(--neutral-transparent);
}
.navigation button.dropdown-trigger {
  text-align:left;
}
.navigation button.dropdown-trigger {
  font-family:var(--bh-ff-body);
}
.navigation button.dropdown-trigger {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}
.navigation button.dropdown-trigger {
  font-size:var(--bh-fs-body-01);
  line-height:var(--bh-lh-body-01);
  letter-spacing:var(--bh-ls-body-01);
}
.navigation button.dropdown-trigger {
  font-weight:var(--fw-bold);
}
.navigation button.dropdown-trigger ghs-icon {
  display:flex;
}
.navigation button.dropdown-trigger ghs-icon {
  height:1.5rem;
}
.navigation button.dropdown-trigger ghs-icon {
  width:1.5rem;
}
.navigation button.dropdown-trigger ghs-icon {
  align-items:center;
}
.navigation button.dropdown-trigger ghs-icon {
  justify-content:center;
}
.navigation button.dropdown-trigger ghs-icon {
  padding-left:0.5rem;
}
.navigation button.dropdown-trigger ghs-icon {
  color:var(--bh-brand-primary-default);
}
.navigation button.dropdown-trigger ghs-icon {
  transition-duration:300ms;
}
.navigation button.dropdown-trigger ghs-icon{
      transition-property:transform;
    }
.navigation button.dropdown-trigger a {
  width:auto;
}
.navigation button.dropdown-trigger:hover, .navigation button.dropdown-trigger:active {
  cursor:pointer;
}
.navigation button.dropdown-trigger:hover ghs-icon, .navigation button.dropdown-trigger:active ghs-icon {
  color:var(--bh-brand-primary-dark);
}
.navigation button.dropdown-trigger:hover ghs-icon, .navigation button.dropdown-trigger:active ghs-icon{
        transform:translateY(20%);
      }
.navigation a.is-active{
    pointer-events:none;
    cursor:default;
  }
.navigation a.is-active {
  background-color:var(--bh-brand-primary-default);
}
.navigation a.is-active {
  color:var(--bh-neutral-white);
}
:host([is-subnav]) nav > ul {
  gap:1.5rem;
}
`;